.kdx-testimonial {
    background: #F5F5F5;
    padding: 48px;
    border-radius: 10px;
    color: #000;

    .quote {
        @include line-height(27);
    }
    .testimonial-footer {
        display: flex;
        align-items: center;

        .photo {            
            
            img {
                width: 78px;
                height: 78px;
                object-fit: cover;
                object-position: top center;
                border-radius: 100%;
            }
        }

        .author-info {
            width: calc(100% - 78px);
            padding-left: 16px;

            .author {
                @include text-size(15);
                @include line-height(24);
                font-weight: 600;
                font-family: $font-family-primary;
                margin: 0 0 4px 0;
                color: #000;
            }
            .author-role {
                color: #000;
                @include text-size(15);
                @include line-height(24);
                font-style: italic;
                font-weight: 400;
                font-family: $font-family-primary;
                margin: 0;
            }
        }
    }
}
